import { WHATS_APP, MessageMedium } from 'constants/messageMediums';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendWhatsAppEditor = (props: BaseSendEditorProps) => {
  return <BaseSendEditor {...props} messageMedium={WHATS_APP as unknown as MessageMedium} />;
};
